import moment from "moment";
import { useRef } from "react";
import { Parser } from "node-sql-parser";
import {
  downloadRuleHistory,
  downloadExecutionHistory,
  downloadSummaryOutput,
  downloadDetailedOutput,
  downloadValidateSummaryOutput,
  downloadValidationDetailedOutput,
} from "../executionHistoryService";
import { toast, cssTransition } from "react-toastify";
import base from "../../middlewares/interceptors";
import {
  getConnectionKeyExportJsonUrl,
  getDomainExportJsonUrl,
  getFileProcessingAttributesExportJsonUrl,
  getLinkedServiceExportJsonUrl,
  getResourceColumnExportJsonUrl,
  getResourceExportJsonUrl,
  getRuleExportJsonUrl,
  getRunInstanceExportJsonUrl,
  getGenericResearchQueryExportJsonUrl,
  getComparisonResearchQueryExportJsonUrl,
} from "../constants";
import { downloadFileSecurely } from "../fileDownloadService";

export const getDateFromTimestamp = (timestamp: number) => {
  const date = new Date(timestamp);

  return date.toDateString();
};
export const getFormatedDate = (dateString: string) => {
  const date = new Date(dateString);

  return date.toDateString();
};

export const isStateTrue = (state: string) => {
  const newState =
    state === "Y" ||
    state === "y" ||
    state === "Yes" ||
    state === "yes" ||
    state === "true";
  return newState;
};

export const setDataType = (fileItem: string) => {
  let newItem;
  switch (fileItem) {
    case "varchar":
      newItem = "string";
      break;
    case "decimal":
      newItem = "decimal";
      break;
    case "integer":
      newItem = "integer";
      break;
    case "DateTime":
      newItem = "datetime";
      break;
    case "datetime":
      newItem = "datetime";
      break;
    default:
      newItem = "string";
      break;
  }

  return newItem;
};
export const setSeverityLevel = (severityLevel: string) => {
  let newSeverityLevel;
  switch (severityLevel) {
    case "medium":
      newSeverityLevel = "Medium";
      break;
    case "high":
      newSeverityLevel = "High";
      break;
    default:
      newSeverityLevel = "Low";
      break;
  }

  return newSeverityLevel;
};

export const convertToReadableFormat = (str: string) => {
  // Convert 'AccountCode' to 'Account Code'
  str = str.replace(/([a-z])([A-Z])/g, "$1 $2");
  // Convert 'Account_Code' to 'Account Code'
  str = str.replace(/_/g, " ");
  return str;
};

export const validateSQLQueryRegex = (sqlQuery: any, CDMColumns: any) => {
  const columnNamesWithOperators =
    sqlQuery.match(/SELECT\s+(.+?)\s+FROM/i)?.[1]?.split(",") ?? [];

  const columnNames = columnNamesWithOperators.map(
    (columnWithOperator: any) => {
      const columnName = columnWithOperator.trim();

      const hasAggregateFunction = columnName.match(/^(COUNT|MAX|MIN)\(.+\)$/);

      if (hasAggregateFunction) {
        return columnName.replace(/^(COUNT|MAX|MIN)\(/, "").replace(")", "");
      }

      return columnName;
    },
  );

  const invalidColumns = columnNames.filter(
    (columnName: any) => !CDMColumns.includes(columnName),
  );

  return invalidColumns;
};

export const validateSQLQuery = (sqlQuery: any) => {
  const parser = new Parser();
  const ast = parser.astify(sqlQuery);

  if (ast instanceof Error) {
    return `Syntax error in SQL query: ${ast.message}`;
  }

  return "SQL query is valid";
};

export const getFormattedDate = (dateString: any) => {
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

export const getFormattedTime = (dateString: any) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString();
};

export const getFormattedDateTime = (dateString: any) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  const formattedDate = `${year}-${month}-${day}`;

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const formattedTime = `${hours}:${minutes}:${seconds}`;

  return `${formattedDate} ${formattedTime}`;
};

/**
 * Calculates the number of days between the first occurrence date and the current date.
 * @param firstOccurrence - The first occurrence date string (ISO format)
 * @returns The number of days in queue, or 0 if firstOccurrence is null/undefined
 */
export const calculateDaysInQueue = (
  firstOccurrence: string | null | undefined,
): number => {
  if (!firstOccurrence) {
    return 0;
  }

  try {
    const today = new Date(new Date().toISOString().split("T")[0]);
    const firstOccurrenceDate = new Date(firstOccurrence.split("T")[0]);
    const diffInDays =
      (today.getTime() - firstOccurrenceDate.getTime()) / (1000 * 3600 * 24);
    return diffInDays;
  } catch (error) {
    // If date parsing fails, return 0
    return 0;
  }
};

export const getFormattedDateTimeWithAMPM = (dateString: any) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  const formattedDate = `${year}-${month}-${day}`;

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedHours = hours.toString().padStart(2, "0");

  const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;

  return `${formattedDate} ${formattedTime}`;
};
export const getFormattedDateInYYMMDD = (dateString: any) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  const formattedDate = `${year}/${month}/${day}`;
  return `${formattedDate}`;
};
export const getFormattedTimeInDobuleDigit = (dateString: any) => {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
  return formattedTime;
};
export const getFormattedDateTimeWithT = (dateString: any) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  const formattedDate = `${year}-${month}-${day}`;

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const formattedTime = `${hours}:${minutes}:${seconds}`;

  // Format as YYYY-MM-DDTHH:MM:SS
  return `${formattedDate}T${formattedTime}`;
};

// when time in seconds and need to convert in HHMMSS
export const getTimeInHHMMSS = (durationInSeconds: number): string => {
  const hours = Math.floor(durationInSeconds / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((durationInSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (durationInSeconds % 60).toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

// Set default date 1 Jan of current year

export const convertDateFormattoDMY = (inputDate: string) => {
  const dateObject = new Date(inputDate);

  const formattedDate = dateObject.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
};

// Sanatized the string

export const getSanatizedCode = (inputString: any, separator: string = "") => {
  if (inputString == null) {
    return null;
  }
  inputString = JSON.stringify(inputString);
  // Define a regular expression pattern for the characters to replace
  const pattern = /[{}()"`\\']/g;
  // Replace characters with an empty string and then trim the result
  const result = inputString.replace(pattern, "").trim();
  if (separator !== "") {
    const newArr = result.split(separator);
    // Check if newArr has more than 1 element to add <ul> and <li> tags
    if (newArr.length > 1) {
      return `<ul class="ul-inside-grid">${newArr
        .map((arr: any) => `<li>${arr}</li>`)
        .join("")}</ul>`;
    } else {
      // If there is only one element, just return it without <ul> and <li>
      return `<div class="word-break-all">${newArr[0]}</div>`;
    }
  }
  return result;
};

// QA asked to remove () and / open and close brackets and backslash
export const getSanatizedCodeForValidate = (inputString: any) => {
  if (inputString == null) {
    return null;
  }
  inputString = JSON.stringify(inputString);
  // Define a regular expression pattern for the characters to replace
  const pattern = /[{}"'`\\]/g;
  // Replace characters with an empty string and then trim the result
  const result = inputString.replace(pattern, "").trim();
  return result;
};

export const formatDate = (dateString: string, format: string) => {
  return moment(new Date(dateString)).format(format);
};

export const formattedJson = (jsonString: string) => {
  try {
    const parsedJson = jsonString && JSON.parse(jsonString);
    return JSON.stringify(parsedJson, null, 2);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    // Return the original string if it's not valid JSON
    return jsonString;
  }
};

export const RemoveTextAndSanatizedCode = (
  inputString: any,
  searchString: any,
  newString: any,
) => {
  if (inputString == null) {
    return null;
  }
  inputString = JSON.stringify(inputString);
  inputString = inputString.replace(new RegExp(searchString, "g"), newString);
  // Define a regular expression pattern for the characters to replace
  const pattern = /[{}()"'/`\\]/g;
  // Replace characters with an empty string and then trim the result
  const result = inputString.replace(pattern, "").trim();
  return result;
};

// this function is used for download excel file from UTF 8
export const downloadExcelFileFromUTF = (response: any, fileName: string) => {
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const downloadexcelfile = document.createElement("a");
  downloadexcelfile.href = url;
  downloadexcelfile.download = fileName;
  document.body.appendChild(downloadexcelfile);
  downloadexcelfile.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(downloadexcelfile);
  toast.success("File Downloaded");
};

// This function is used to download a JSON file
export const downloadJsonFile = (response: any, fileName: string) => {
  const json = JSON.stringify(response.data, null, 2); // Convert response data to JSON string
  const blob = new Blob([json], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);
  const downloadJsonFile = document.createElement("a");
  downloadJsonFile.href = url;
  downloadJsonFile.download = fileName;
  document.body.appendChild(downloadJsonFile);
  downloadJsonFile.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(downloadJsonFile);
  toast.success(
    `${response?.data?.entity_name
      .replace(/_/g, " ")
      .replace(/\b\w/g, (match: string) => match.toUpperCase())} ${
      response?.data?.entity_description?.id
    } exported successfully!`,
  );
};

// this function is used for rule history download button
export const downloadRulesHistoryFile = async ({
  setLoading,
  searchFilterData,
}: any) => {
  try {
    setLoading(true);
    await downloadRuleHistory({
      searchFilterData,
    });
  } catch (error) {
    // Handle any potential errors here
    console.error("Error fetching execution history:", error);
  } finally {
    setLoading(false);
  }
};

// this function is used for execution history download button
export const downloadExecutionHistoryFile = async ({
  setLoading,
  searchFilterData,
}: any) => {
  try {
    setLoading(true);
    await downloadExecutionHistory({
      searchFilterData,
    });
  } catch (error) {
    // Handle any potential errors here
    console.error("Error fetching execution history file:", error);
  } finally {
    setLoading(false);
  }
};

// this function is used for summary output download button
export const downloadSummaryOutputFile = async (
  runName: string | null,
  runDate: string | null,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await downloadSummaryOutput(runName, runDate);
  } catch (error) {
    // Handle any potential errors here
    console.error("Error fetching summary output history file:", error);
  } finally {
    setLoading(false);
  }
};
// this function is used for detailed output download button
export const downloadDetailedOutputFile = async (
  runName: string | null,
  runDate: string | null,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await downloadDetailedOutput(runName, runDate);
  } catch (error) {
    // Handle any potential errors here
    console.error("Error fetching detailed output history file:", error);
  } finally {
    setLoading(false);
  }
};
// this function is used for validate summary output download button
export const downloadValidationSummaryOutputFile = async (
  runName: string | null,
  runDate: string | null,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await downloadValidateSummaryOutput(runName, runDate);
  } catch (error) {
    // Handle any potential errors here
    console.error(
      "Error fetching validate summary output history file:",
      error,
    );
  } finally {
    setLoading(false);
  }
};
// this function is used for validate detailed output download button
export const downloadValidationDetailedOutputFile = async (
  runName: string | null,
  runDate: string | null,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await downloadValidationDetailedOutput(runName, runDate);
  } catch (error) {
    // Handle any potential errors here
    console.error(
      "Error fetching validate detailed output history file:",
      error,
    );
  } finally {
    setLoading(false);
  }
};

export const exportJsonFile = async (
  url: any,
  id: number,
  fileName: any,
  status?: boolean,
) => {
  try {
    // const response = await base.get(
    //   `${url}/${id}?is_export_associate_entities=${status}`
    // );

    const apiEndPoint =
      status !== undefined
        ? `${id}?is_export_associate_entities=${status}`
        : `${id}`;

    const response = await base.get(`${url}/${apiEndPoint}`);

    if (response.status >= 200 && response.status < 300) {
      downloadJsonFile(response, fileName);
    } else {
      console.error(`HTTP error! Status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const downloadDomainExportFile = async (
  id: number,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(getDomainExportJsonUrl, id, "Domain-Json");
  } catch (error) {
    console.error("Error fetching domain-json file :", error);
  } finally {
    setLoading(false);
  }
};

export const downloadResourceExportFile = async (
  id: number,
  status: boolean,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(getResourceExportJsonUrl, id, "Resource-Json", status);
  } catch (error) {
    console.error("Error fetching resource-json file:", error);
  } finally {
    setLoading(false);
  }
};

export const downloadResourceColumnExportFile = async (
  id: number,
  status: boolean,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(
      getResourceColumnExportJsonUrl,
      id,
      "Resource-Column-Json",
      status,
    );
  } catch (error) {
    console.error("Error fetching resource-column-json file:", error);
  } finally {
    setLoading(false);
  }
};
export const downloadRuleExportFile = async (
  id: number,
  status: boolean,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(getRuleExportJsonUrl, id, "Rule-Json", status);
  } catch (error) {
    console.error("Error fetching rule-json file:", error);
  } finally {
    setLoading(false);
  }
};
export const downloadConnectionKeyExportFile = async (
  id: number,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(
      getConnectionKeyExportJsonUrl,
      id,
      "Connection-Key-Json",
    );
  } catch (error) {
    console.error("Error fetching connection-key-json file:", error);
  } finally {
    setLoading(false);
  }
};
export const downloadLinkedServiceExportFile = async (
  id: number,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(
      getLinkedServiceExportJsonUrl,
      id,
      "Linked-Service-Json",
    );
  } catch (error) {
    console.error("Error fetching linked-service-json file:", error);
  } finally {
    setLoading(false);
  }
};

export const downloadFileProcessingAttributesExportFile = async (
  id: number,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(
      getFileProcessingAttributesExportJsonUrl,
      id,
      "File-Processing-Attributes-Json",
    );
  } catch (error) {
    console.error(
      "Error fetching file-processing-attributes-json file:",
      error,
    );
  } finally {
    setLoading(false);
  }
};
export const downloadRunInstanceExportFile = async (
  id: number,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(getRunInstanceExportJsonUrl, id, "Run-Instance-Json");
  } catch (error) {
    console.error("Error fetching run-instance-json file:", error);
  } finally {
    setLoading(false);
  }
};

export const downloadGenericResearchQueryExportFile = async (
  id: number,
  status: boolean,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(
      getGenericResearchQueryExportJsonUrl,
      id,
      "Generic-Research-Query-Json",
      status,
    );
  } catch (error) {
    console.error("Error fetching generic-research-query-json file:", error);
  } finally {
    setLoading(false);
  }
};

export const downloadComparisonResearchQueryExportFile = async (
  id: number,
  status: boolean,
  setLoading?: any,
) => {
  try {
    setLoading(true);
    await exportJsonFile(
      getComparisonResearchQueryExportJsonUrl,
      id,
      "Comparison-Research-Query-Json",
      status,
    );
  } catch (error) {
    console.error("Error fetching comparison-research-query-json file:", error);
  } finally {
    setLoading(false);
  }
};

export const getCurrentDateAndLast7Days = () => {
  const currentDate = new Date();
  const last7DaysDate = new Date(currentDate);
  last7DaysDate.setDate(currentDate.getDate() - 7);
  const formattedLast7DaysDate = formatDate(
    last7DaysDate.toString(),
    "YYYY-MM-DD",
  );
  return {
    last7DaysDate: formattedLast7DaysDate,
  };
};

export const removeUndefinedProperties = (obj: any): any => {
  if (Array.isArray(obj)) {
    // If obj is an array, recursively call removeUndefinedProperties for each element
    return obj.map((item: any) => removeUndefinedProperties(item));
  }

  const newObj: any = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (obj[key] !== undefined) {
        if (
          typeof obj[key] === "object" &&
          obj[key] !== null &&
          !Array.isArray(obj[key])
        ) {
          // Recursively call removeUndefinedProperties for nested objects
          newObj[key] = removeUndefinedProperties(obj[key]);
        } else {
          // Copy non-undefined values to the new object
          newObj[key] = obj[key];
        }
      }
    }
  }

  return newObj;
};

export const extractFileAndDirectoriesName = (filepath: string) => {
  const cleanedPath = filepath.replace(/\\\\/g, "\\");
  return cleanedPath.split("\\");
};

export const manageAvailableColumns = (
  columns: string[],
  columnName: string,
  action: "toggle" | "remove" | "add" | "update",
  newColumnName?: any,
): string[] => {
  // Find the index of the existing column name
  const index = columns.indexOf(columnName);

  switch (action) {
    case "toggle":
      if (index !== -1) {
        // If the column exists, remove it
        return [...columns.slice(0, index), ...columns.slice(index + 1)];
      } else {
        // If it doesn't exist, add it
        return [...columns, columnName];
      }

    case "remove":
      if (index !== -1) {
        // If the column exists, remove it
        return [...columns.slice(0, index), ...columns.slice(index + 1)];
      }
      return columns; // If it doesn't exist, return as is

    case "add":
      if (index === -1) {
        // If the column doesn't exist, add it
        return [...columns, newColumnName];
      }
      return columns; // If it already exists, do nothing

    case "update":
      if (index !== -1 && newColumnName) {
        // If the column exists, update it with the new name
        const updatedColumns = [...columns];
        updatedColumns[index] = newColumnName;
        return updatedColumns;
      }
      // if (index === -1) {
      //   // If the column doesn't exist, add it
      //   return [...columns, columnName];
      // }
      return columns; // If it doesn't exist or no new name provided, return as is

    default:
      return columns; // Default case, return the original array
  }
};

export const getFormattedKeysPairs = (inputString: string) => {
  const pairs: any = {};
  inputString.split(",").forEach((pair) => {
    const [key, value] = pair.trim().split("=");
    pairs[key] = value;
  });
  return pairs;
};

export const combineArrays = (arr1: string[], arr2: string[]): string[] => {
  // Create a set from arr1 for quick lookup
  const set1 = new Set(arr1);

  // Filter arr2 to exclude elements that are present in arr1
  const filteredArr2 = arr2.filter((item) => !set1.has(item));

  // Combine arr1 with the filtered arr2
  const resultArray = [...arr1, ...filteredArr2];

  return resultArray;
};

/**
 * Deduplicates an array of objects based on a specified field property.
 * Keeps the first occurrence of each unique field value and removes subsequent duplicates.
 *
 * This is particularly useful for deduplicating data grid columns, form fields, or any
 * array of objects where you want to ensure uniqueness based on a specific property.
 *
 * @template T - The type of objects in the array
 * @param {T[]} items - The array of objects to deduplicate
 * @param {keyof T} fieldProperty - The property name to use for deduplication
 * @returns {T[]} A new array with duplicates removed, keeping the first occurrence of each unique field value
 *
 * @example
 * // Deduplicate columns by their 'field' property
 * const columns = [
 *   { field: 'name', headerName: 'Name' },
 *   { field: 'email', headerName: 'Email' },
 *   { field: 'name', headerName: 'Full Name' } // duplicate
 * ];
 * const uniqueColumns = deduplicateByFieldProperty(columns, 'field');
 * // Result: [
 * //   { field: 'name', headerName: 'Name' },
 * //   { field: 'email', headerName: 'Email' }
 * // ]
 */
export const deduplicateByFieldProperty = <T extends Record<string, any>>(
  items: T[],
  fieldProperty: keyof T,
): T[] => {
  return items.reduce((uniqueItems: T[], item: T) => {
    const fieldExists = uniqueItems.some(
      (existingItem) => existingItem[fieldProperty] === item[fieldProperty],
    );
    if (!fieldExists) {
      uniqueItems.push(item);
    }
    return uniqueItems;
  }, []);
};

export const extractVariables = (query: any) => {
  const matches = query?.match(/\$\$(.*?)\$\$/g);
  if (!matches) return [];
  return matches.map((match: any) => match.slice(2, -2).toLowerCase());
};
/**
 * Recursively removes specified keys from an object or an array of objects.
 *
 * This function traverses through the provided data structure and removes the
 * keys listed in `keysToRemove`. It handles nested objects and arrays, ensuring
 * that the specified keys are removed at all levels of the data structure.
 *
 * @param {any} data - The data structure from which keys need to be removed.
 *                      It can be an object, an array of objects, or a primitive value.
 * @param {string[]} keysToRemove - An array of keys that should be removed from the data.
 * @returns {any} - A new data structure with the specified keys removed.
 **/

export const removeKeys = (data: any, keysToRemove: string[]): any => {
  if (Array.isArray(data)) {
    return data.map((item) => removeKeys(item, keysToRemove));
  } else if (typeof data === "object" && data !== null) {
    const filteredData: any = {};
    Object.keys(data).forEach((key) => {
      if (!keysToRemove.includes(key)) {
        filteredData[key] = removeKeys(data[key], keysToRemove);
      }
    });
    return filteredData;
  }
  return data;
};
interface Chip {
  name: string;
  value: string;
}

export function replaceQueryToDomainMapped(
  query: string,
  chips: Chip[],
): string {
  // Iterate through each chip and replace the placeholders
  chips.forEach((chip) => {
    // Create a regular expression to match the placeholders
    const placeholder = new RegExp(
      `\\[##(MISSING|MISMATCHED|MERGED)## ${chip.name.replace(".", "\\.")}]`,
      "g",
    );

    // Replace the placeholders with the chip's value
    query = query.replace(placeholder, `[##$1## ${chip.value}]`);
  });

  // Return the modified query
  return query;
}

export function replaceQueryFromDomainMapped(
  query: string,
  chips: Chip[],
): string {
  // Iterate through each chip and replace the placeholders
  chips.forEach((chip) => {
    // Create a regular expression to match the placeholders
    const placeholder = new RegExp(
      `\\[##(MISSING|MISMATCHED|MERGED)## ${chip.value.replace(".", "\\.")}]`,
      "g",
    );

    // Replace the placeholders with the chip's value
    query = query.replace(placeholder, `[##$1## ${chip.name}]`);
  });

  // Return the modified query
  return query;
}
export const removeCheckboxFromJson = (compareData: any) => {
  const compareDataDuplicate = JSON.parse(JSON.stringify(compareData));
  if (
    compareDataDuplicate.hasOwnProperty("checkbox") &&
    Object.keys(compareDataDuplicate.checkbox).length === 0
  ) {
    delete compareDataDuplicate.checkbox;
  }

  return compareDataDuplicate;
};
export const extractColumnNamesFromQuery = (query: string) =>
  query
    ?.match(/"([^"]+)"/g)
    ?.map((name) => name.replace(/[^\w\s/]/g, "").trim()) || [];
export const stripExactTrailingResourceSuffix = (
  value: string,
  suffix?: string,
): string => {
  if (!value || !suffix) {
    return value;
  }

  const normalizedSuffix = String(suffix).trim();
  if (!normalizedSuffix) {
    return value;
  }

  const suffixPattern = `_${normalizedSuffix}`;
  return value.endsWith(suffixPattern)
    ? value.slice(0, -suffixPattern.length)
    : value;
};

export const stripTrailingResourceSuffix = (
  value: string,
  suffix?: string,
): string => {
  if (!value) {
    return value;
  }

  if (suffix) {
    return stripExactTrailingResourceSuffix(value, suffix);
  }

  const segments = value.split("_");
  if (segments.length <= 1) {
    return value;
  }

  const isLikelyResourceSuffix = (suffixText: string): boolean => {
    if (!suffixText || suffixText.trim() === "") {
      return false;
    }

    const resourcePattern = /^[A-Za-z0-9_]+$/;
    if (!resourcePattern.test(suffixText)) {
      return false;
    }

    const allSegments = suffixText.split("_").filter(Boolean);
    if (allSegments.length === 0) {
      return false;
    }

    const [firstSegment, ...restSegments] = allSegments;
    if (!/^(?:[A-Z][A-Za-z0-9]*|\d+)$/.test(firstSegment)) {
      return false;
    }

    return restSegments.every((segment) => {
      if (/^\d+$/.test(segment)) {
        return true;
      }

      return /^[A-Z][A-Za-z0-9]*$/.test(segment);
    });
  };

  let bestMatch = value;
  for (let idx = segments.length - 1; idx > 0; idx -= 1) {
    const suffixText = segments.slice(idx).join("_");
    const base = segments.slice(0, idx).join("_");

    if (base && isLikelyResourceSuffix(suffixText)) {
      bestMatch = base;
    }
  }

  return bestMatch;
};

export const isResourceColumnNameValid = (
  columnName: string,
  availableColumns: string[] = [],
  suffix?: string,
): boolean => {
  const normalizedColumn = String(columnName ?? "").trim();
  const normalizedAvailableColumns = (availableColumns || []).map((name) =>
    String(name ?? "").trim(),
  );

  if (!normalizedColumn) {
    return false;
  }

  const equivalentCandidates = new Set<string>(normalizedAvailableColumns);
  normalizedAvailableColumns.forEach((availableColumn) => {
    const strippedAvailableColumn = stripTrailingResourceSuffix(
      availableColumn,
      suffix,
    );
    if (strippedAvailableColumn !== availableColumn) {
      equivalentCandidates.add(strippedAvailableColumn);
    }
  });

  if (equivalentCandidates.has(normalizedColumn)) {
    return true;
  }

  const strippedColumn = stripTrailingResourceSuffix(normalizedColumn, suffix);
  return (
    strippedColumn !== normalizedColumn &&
    equivalentCandidates.has(strippedColumn)
  );
};

export const extractDollarPrefixedColumns = (query: string) => {
  if (!query) return [];
  // 1) Match all quoted parts like " ... "
  const allQuotes = query.match(/"[^"]+"/g) || [];
  // 2) Remove valid escaped patterns with exactly two $ at start and end
  let cleanedQuery = query;
  allQuotes.forEach((quote) => {
    const prefixMatch = quote.match(/^"(\$+)/);
    const suffixMatch = quote.match(/(\$+)"$/);
    if (prefixMatch && suffixMatch) {
      const prefixCount = prefixMatch[1].length;
      const suffixCount = suffixMatch[1].length;
      if (prefixCount === 2 && suffixCount === 2) {
        cleanedQuery = cleanedQuery.replace(quote, "");
      }
    }
  });
  // 3) Extract remaining quoted names
  const remainingQuotes = cleanedQuery.match(/"[^"]+"/g) || [];
  // 4) Clean the column names by removing quotes only (keep spaces, dashes, underscores)
  return remainingQuotes.map((name) => name.replace(/"/g, "").trim());
};
export const fadeSlide = cssTransition({
  enter: "fadeSlideIn",
  exit: "fadeSlideOut",
});
export const useToast = () => {
  const toastIdRef = useRef<string | null | number>(null);
  const showToast = (
    message: any,
    type: "error" | "warning" | "success" | "warn",
    transition?: any,
  ) => {
    const appliedTransition = transition || fadeSlide;
    toast.dismiss();
    toastIdRef.current = toast[type](message, {
      transition: appliedTransition,
    });
  };
  return { showToast };
};

export const extractApiErrorMessage = (
  error: any,
  fallback: string,
): string => {
  const data = error?.response?.data;
  if (!data) return fallback;

  if (data.message) {
    return String(data.message);
  }

  if (Array.isArray(data.detail)) {
    const messages = data.detail
      .map((err: any) => {
        const msg = err?.msg || err?.message;
        if (!msg) return null;
        if (Array.isArray(err.loc) && err.loc.length > 0) {
          const fieldPath = err.loc
            .filter((part: any) => part !== "body")
            .join(" → ");
          if (fieldPath) {
            return `${fieldPath}: ${msg}`;
          }
        }
        return msg;
      })
      .filter(Boolean);
    if (messages.length > 0) {
      return messages.join("; ");
    }
  }

  if (typeof data.detail === "string") {
    return data.detail;
  }

  return fallback;
};

export const calculateDynamicWidth = (
  key: string,
  comparison_rule_exec_details: any[],
  type: string,
) => {
  let maxKeyLength = 0;
  let maxValueLength = 0;

  comparison_rule_exec_details.forEach((execDetail: any) => {
    const recordData =
      type.toLowerCase() === "missmatched"
        ? execDetail?.mismatched_record_details?.record_snapshot?.record_data
        : execDetail?.missing_record_details?.record_snapshot?.record_data;

    if (recordData && recordData[key]) {
      maxKeyLength = Math.max(maxKeyLength, key.length);
      maxValueLength = Math.max(maxValueLength, String(recordData[key]).length);
    }
  });

  return Math.max(maxKeyLength, maxValueLength) * 9.2;
};

export const calculateDynamicWidthForSnapshot = (
  key: string,
  comparison_rule_exec_details: any[],
  type: string,
) => {
  let maxKeyLength = 0;
  let maxValueLength = 0;

  comparison_rule_exec_details.forEach((execDetail: any) => {
    const recordData =
      type.toLowerCase() === "missmatched"
        ? execDetail?.record_snapshot?.record_data
        : execDetail?.record_snapshot?.record_data;

    if (recordData && recordData[key]) {
      maxKeyLength = Math.max(maxKeyLength, key.length);
      maxValueLength = Math.max(maxValueLength, String(recordData[key]).length);
    }
  });

  return Math.max(maxKeyLength, maxValueLength) * 9.2;
};
export function capitalize(str: string) {
  if (!str) return str; // handle empty or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
/**
 * Formats a number with US-style comma separators
 * @param num - The number to format (can be number or string)
 * @returns Formatted number string with comma separators (e.g., 12345679 → "12,345,679")
 */
export const formatNumberWithCommas = (
  num: number | string | null | undefined,
): string => {
  if (num === null || num === undefined) {
    return "0";
  }
  // Convert to number if it's a string
  const numValue = typeof num === "string" ? parseFloat(num) : num;
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return "0";
  }
  // Use toLocaleString to format with US locale (comma separators)
  return numValue.toLocaleString("en-US");
};
export const forceLogDownload = async (downloadLink: any, fileName: any) => {
  try {
    const token = localStorage.getItem("token");
    // const response = await fetch(
    //   "download-files/EngineLogs/research_query_execution_340_logs.log",
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
    const response = await fetch(downloadLink, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch file");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "downloaded-file.log";
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed", error);
  }
};
export function createSetLoading<T extends Record<string, boolean>>(
  setState: React.Dispatch<React.SetStateAction<T>>,
) {
  return (key: keyof T) => (value: React.SetStateAction<boolean>) => {
    setState((prev) => ({
      ...prev,
      [key]:
        typeof value === "function"
          ? (value as (val: boolean) => boolean)(prev[key])
          : value,
    }));
  };
}

export const handleSecureDownload = async (
  filepath: string,
  fileName: string,
) => {
  try {
    await downloadFileSecurely(filepath, fileName, false);
  } catch (error) {
    console.error("Download failed:", error);
    // Error handling is done in the downloadFileSecurely function
  }
};

// Rule dashboard functions

/**
 * Type definition for record types in rule dashboard
 */
export type RecordType = "missing" | "mismatched";

/**
 * Interface for grouped fields by prefix
 */
export interface GroupedFields {
  [prefix: string]: string[];
}

/**
 * Interface for field to prefix mapping
 */
export interface FieldToPrefixMap {
  [field: string]: string;
}

/**
 * Prefix shared by every internal false positive indicator field. Covers the
 * legacy "FP_Ind_{prefix}" shape and the current
 * "FP_Ind_{resource_id}_{prefix}" shape. Resource prefixes may contain special
 * characters (e.g. "GWP@2609"), so the suffix is deliberately not pattern matched.
 */
const FP_IND_FIELD_PREFIX = "FP_Ind_";

/**
 * Checks whether a field is an internal false positive indicator column that
 * must never be surfaced on the comparison dashboard
 * @param field - The field name
 * @returns True when the field is internal and should be hidden
 */
export const isFpIndicatorColumn = (field: string): boolean =>
  typeof field === "string" && field.startsWith(FP_IND_FIELD_PREFIX);

/**
 * Removes internal technical fields from a list of field names
 * @param fields - Array of field names
 * @returns Array of field names without internal fields
 */
export const excludeInternalResultFields = (fields: string[]): string[] =>
  fields.filter((field) => !isFpIndicatorColumn(field));

/**
 * Removes internal technical columns from a list of column definitions
 * @param columns - Array of column definitions
 * @returns Array of column definitions without internal columns
 */
export const excludeInternalResultColumns = <T extends { field: string }>(
  columns: T[],
): T[] => columns.filter((column) => !isFpIndicatorColumn(column?.field));

/**
 * Reserved key inside `false_positive_missings` holding the map of resource
 * prefix to the secondary merge resource that fulfilled the missing record
 */
export const SECONDARY_MERGE_RESOURCES_KEY = "__secondary_merge_resources__";

/**
 * Shape of the `false_positive_missings` payload of a missing record. A
 * resource prefix entry set to true only means "not really missing", which can
 * be a backup key match or a secondary resource fulfilment. Only the reserved
 * secondary merge resources map identifies a secondary resource fulfilment.
 */
export interface FalsePositiveMissings {
  __secondary_merge_resources__?: Record<string, string>;
  [resourcePrefix: string]: boolean | Record<string, string> | undefined;
}

/**
 * Extracts the secondary merge resources of a missing record, keeping only the
 * prefixes fulfilled by a named secondary resource
 * @param falsePositiveMissings - The false_positive_missings payload
 * @returns Map of resource prefix to secondary resource name
 */
export const getSecondaryMergeResources = (
  falsePositiveMissings: FalsePositiveMissings | undefined | null,
): Record<string, string> => {
  const secondaryMergeResources =
    falsePositiveMissings?.[SECONDARY_MERGE_RESOURCES_KEY];
  if (!secondaryMergeResources || typeof secondaryMergeResources !== "object") {
    return {};
  }

  return Object.entries(secondaryMergeResources).reduce(
    (fulfilled: Record<string, string>, [prefix, resourceName]) => {
      if (typeof resourceName === "string" && resourceName.trim() !== "") {
        fulfilled[prefix] = resourceName;
      }
      return fulfilled;
    },
    {},
  );
};

/**
 * Returns the secondary resource that fulfilled a missing record for a prefix.
 * Prefix casing is not guaranteed to match the prefixes advertised in
 * "additional_properties.resource_prefixes" (e.g. "gwp" against "GWP"), so the
 * lookup falls back to a case insensitive match
 * @param secondaryMergeResources - Map of resource prefix to secondary resource name
 * @param resourcePrefix - The resource prefix of the column
 * @returns The secondary resource name, or an empty string when not fulfilled
 */
export const getSecondaryMergeResourceName = (
  secondaryMergeResources: Record<string, string> | undefined | null,
  resourcePrefix: string,
): string => {
  if (!secondaryMergeResources || typeof resourcePrefix !== "string") return "";

  const targetPrefix = resourcePrefix.toLowerCase();
  const matchedPrefix =
    resourcePrefix in secondaryMergeResources
      ? resourcePrefix
      : Object.keys(secondaryMergeResources).find(
          (prefix) => prefix.toLowerCase() === targetPrefix,
        );

  const resourceName = matchedPrefix
    ? secondaryMergeResources[matchedPrefix]
    : undefined;

  return typeof resourceName === "string" && resourceName.trim() !== ""
    ? resourceName
    : "";
};

/**
 * Helper function to get record details based on record type
 * @param item - The data item containing record details
 * @param recordType - Type of record ('missing' or 'mismatched')
 * @returns The record details object or null
 */
export const getRecordDetails = (item: any, recordType: RecordType) => {
  if (!item) return null;
  const detailsKey =
    recordType === "missing"
      ? "missing_record_details"
      : "mismatched_record_details";
  return item[detailsKey] || null;
};

/**
 * Creates a mapping of fields to their corresponding prefixes
 * @param resultsData - Array of result items from API
 * @param dashboardData - Dashboard data containing resource prefixes
 * @param recordType - Type of record ('missing' or 'mismatched')
 * @returns Object mapping field names to their prefixes
 */
export const getFieldToPrefixMapping = (
  resultsData: any[],
  dashboardData: any,
  recordType: RecordType,
): FieldToPrefixMap => {
  const fieldToPrefixMap: FieldToPrefixMap = {};

  if (!resultsData || !Array.isArray(resultsData) || resultsData.length === 0) {
    return fieldToPrefixMap;
  }

  const firstItem = resultsData[0];
  const recordDetails = getRecordDetails(firstItem, recordType);

  if (!recordDetails) {
    return fieldToPrefixMap;
  }

  const recordData = recordDetails?.record_snapshot?.record_data;
  const comparisonKeys = recordDetails?.comparison_keys;
  const columnValues = recordDetails?.column_values;
  const fileNames = (recordDetails as any)?.file_names;

  let allFields: string[] = [];

  // Collect all fields from different sources
  const recordDataFields = recordData ? Object.keys(recordData) : [];
  const comparisonKeysFields = comparisonKeys
    ? Object.keys(comparisonKeys)
    : [];
  const columnValuesFields = columnValues ? Object.keys(columnValues) : [];
  const fileNameFields = fileNames ? Object.keys(fileNames) : [];

  // Combine all fields (including file_names) and remove duplicates
  const combinedFields = [
    ...recordDataFields,
    ...comparisonKeysFields,
    ...columnValuesFields,
    ...fileNameFields,
  ];

  allFields = excludeInternalResultFields(Array.from(new Set(combinedFields)));

  const preDefinedPrefixes =
    dashboardData?.additional_properties?.resource_prefixes;

  if (!preDefinedPrefixes || !Array.isArray(preDefinedPrefixes)) {
    return fieldToPrefixMap;
  }

  // Map each field to its prefix
  allFields.forEach((field) => {
    // First try to find prefix at the start of the field name
    let predefinedMatch = preDefinedPrefixes.find((prefix: string) =>
      field.startsWith(prefix),
    );

    // If not found at start, look for prefix anywhere in the field name
    // This handles cases like "Mismatched_Factset_Value" where prefix is in the middle
    if (!predefinedMatch) {
      predefinedMatch = preDefinedPrefixes.find(
        (prefix: string) =>
          field.includes(`_${prefix}_`) ||
          field.includes(`_${prefix}`) ||
          field.includes(`${prefix}_`),
      );
    }

    if (predefinedMatch) {
      fieldToPrefixMap[field] = predefinedMatch;
    }
  });

  return fieldToPrefixMap;
};

export const getFieldToPrefixMappingForSnapshot = (
  resultsData: any[],
  dashboardData: any,
  recordType: RecordType,
): FieldToPrefixMap => {
  const fieldToPrefixMap: FieldToPrefixMap = {};

  if (!resultsData || !Array.isArray(resultsData) || resultsData.length === 0) {
    return fieldToPrefixMap;
  }

  const firstItem = resultsData[0];

  if (!firstItem) {
    return fieldToPrefixMap;
  }

  const recordData = firstItem?.record_snapshot?.record_data;
  const comparisonKeys = firstItem?.comparison_keys;
  const columnValues = firstItem?.column_values;

  let allFields: string[] = [];

  // Collect all fields from different sources
  const recordDataFields = recordData ? Object.keys(recordData) : [];
  const comparisonKeysFields = comparisonKeys
    ? Object.keys(comparisonKeys)
    : [];
  const columnValuesFields = columnValues ? Object.keys(columnValues) : [];

  // Combine all fields and remove duplicates
  const combinedFields = [
    ...recordDataFields,
    ...comparisonKeysFields,
    ...columnValuesFields,
  ];

  allFields = excludeInternalResultFields(Array.from(new Set(combinedFields)));

  const preDefinedPrefixes =
    dashboardData?.additional_properties?.resource_prefixes;

  if (!preDefinedPrefixes || !Array.isArray(preDefinedPrefixes)) {
    return fieldToPrefixMap;
  }

  // Map each field to its prefix
  allFields.forEach((field) => {
    // First try to find prefix at the start of the field name
    let predefinedMatch = preDefinedPrefixes.find((prefix: string) =>
      field.startsWith(prefix),
    );

    // If not found at start, look for prefix anywhere in the field name
    // This handles cases like "Mismatched_Factset_Value" where prefix is in the middle
    if (!predefinedMatch) {
      predefinedMatch = preDefinedPrefixes.find(
        (prefix: string) =>
          field.includes(`_${prefix}_`) ||
          field.includes(`_${prefix}`) ||
          field.includes(`${prefix}_`),
      );
    }

    if (predefinedMatch) {
      fieldToPrefixMap[field] = predefinedMatch;
    }
  });

  return fieldToPrefixMap;
};

/**
 * Transforms header name by removing prefix if present at start, middle, or end
 * @param field - The field name
 * @param headerName - The original header name
 * @param fieldToPrefixMap - Mapping of fields to prefixes
 * @returns Transformed header name with prefix removed
 */
export const transformHeaderName = (
  field: string,
  headerName: string,
  fieldToPrefixMap: FieldToPrefixMap,
): string => {
  const prefix = fieldToPrefixMap[field];
  if (!prefix) {
    return headerName;
  }

  // Escape special regex characters in prefix
  const escapedPrefix = prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Replace prefix in different positions
  let result = headerName;

  // Replace middle: _prefix_ -> _
  result = result.replace(new RegExp(`_${escapedPrefix}_`, "g"), "_");

  // Replace start: ^prefix_ -> empty
  result = result.replace(new RegExp(`^${escapedPrefix}_`, "g"), "");

  // Replace end: _prefix$ -> empty
  result = result.replace(new RegExp(`_${escapedPrefix}$`, "g"), "");

  // Replace standalone: ^prefix$ -> empty
  result = result.replace(new RegExp(`^${escapedPrefix}$`, "g"), "");
  return result;
};

/**
 * Gets the first column keys (id + comparison keys) from results data
 * @param resultsData - Array of result items from API
 * @param recordType - Type of record ('missing' or 'mismatched')
 * @returns Array of first column key names
 */
export const getFirstColumnKeys = (
  resultsData: any[],
  recordType: RecordType,
): string[] => {
  if (!resultsData || !Array.isArray(resultsData) || resultsData.length === 0) {
    return ["id"];
  }

  const firstItem = resultsData[0];
  const recordDetails = getRecordDetails(firstItem, recordType);
  const comparisonKeys = recordDetails?.comparison_keys;

  let allKeys = ["id"]; // Start with id

  if (comparisonKeys) {
    allKeys = [...allKeys, ...Object.keys(comparisonKeys)];
  }

  return allKeys;
};

/**
 * Groups fields by their prefixes with enhanced categorization
 * @param resultsData - Array of result items from API
 * @param dashboardData - Dashboard data containing resource prefixes
 * @param recordType - Type of record ('missing' or 'mismatched')
 * @param firstColumnKeys - Array of first column keys to exclude
 * @returns Object with fields grouped by prefix and category
 */
export const groupFieldsByPrefix = (
  resultsData: any[],
  dashboardData: any,
  recordType: RecordType,
  firstColumnKeys: string[],
): GroupedFields => {
  if (!resultsData || !Array.isArray(resultsData) || resultsData.length === 0) {
    return {};
  }

  const firstItem = resultsData[0];
  const recordDetails = getRecordDetails(firstItem, recordType);

  if (!recordDetails) {
    return {};
  }

  const recordData = recordDetails?.record_snapshot?.record_data;
  const comparisonKeys = recordDetails?.comparison_keys;
  const columnValues = recordDetails?.column_values;
  const fileNames = (recordDetails as any)?.file_names;

  let allFields: string[] = [];

  // Collect all fields from different sources
  const recordDataFields = recordData ? Object.keys(recordData) : [];
  const comparisonKeysFields = comparisonKeys
    ? Object.keys(comparisonKeys)
    : [];
  const columnValuesFields = columnValues ? Object.keys(columnValues) : [];
  const fileNameFields = fileNames ? Object.keys(fileNames) : [];

  // Combine all fields (including file_names) and remove duplicates, excluding first column keys
  const combinedFields = [
    ...recordDataFields,
    ...comparisonKeysFields,
    ...columnValuesFields,
    ...fileNameFields,
  ];

  allFields = excludeInternalResultFields(
    Array.from(new Set(combinedFields)).filter(
      (key) => !firstColumnKeys.includes(key),
    ),
  );

  const preDefinedPrefixes =
    dashboardData?.additional_properties?.resource_prefixes;

  if (!preDefinedPrefixes || !Array.isArray(preDefinedPrefixes)) {
    return {};
  }

  // Initialize grouped fields structure
  const groupedFields: GroupedFields = {};
  const resourceFields: string[] = [];
  const commonFields: string[] = [];

  allFields.forEach((field) => {
    // Check if field is a base resource column (exact match with prefix)
    if (preDefinedPrefixes.includes(field)) {
      resourceFields.push(field);
      return;
    }

    // Check if field starts with a predefined prefix
    const prefixMatch = preDefinedPrefixes.find((prefix: string) =>
      field.startsWith(`${prefix}_`),
    );

    if (prefixMatch) {
      // Field belongs to a prefix group
      if (!groupedFields[prefixMatch]) {
        groupedFields[prefixMatch] = [];
      }
      groupedFields[prefixMatch].push(field);
      return;
    }

    // Check if field contains a prefix (for Mismatched_ patterns)
    const containsPrefix = preDefinedPrefixes.find(
      (prefix: string) =>
        field.includes(`_${prefix}`) || field.includes(`${prefix}_`),
    );

    if (containsPrefix) {
      // Field belongs to a prefix group
      if (!groupedFields[containsPrefix]) {
        groupedFields[containsPrefix] = [];
      }
      groupedFields[containsPrefix].push(field);
      return;
    }

    // Field doesn't match any prefix pattern, add to common columns
    commonFields.push(field);
  });

  // For missing records, if no resource fields found in data,
  // create them from predefined prefixes (they don't exist in the data structure)
  if (resourceFields.length === 0 && recordType === "missing") {
    resourceFields.push(...preDefinedPrefixes);
  }

  // Add resource fields as a separate group if any exist
  if (resourceFields.length > 0) {
    groupedFields["Resources"] = resourceFields;
  }

  // Add common fields as a separate group if any exist
  if (commonFields.length > 0) {
    groupedFields["Common Columns"] = commonFields;
  }

  return groupedFields;
};

/**
 * Creates the complete column grouping model for rule dashboard
 * @param dashboardData - Dashboard data containing resource prefixes
 * @param resultsData - Array of result items from API
 * @param recordType - Type of record ('missing' or 'mismatched')
 * @param isAllColumnPinned - Whether all columns are pinned
 * @param resourcesHeaderName - Optional custom header name for Resources section (defaults to "Resources")
 * @returns GridColumnGroupingModel array for the data grid
 */
export const createColumnGroupingModel = (
  dashboardData: any,
  resultsData: any[],
  recordType: RecordType,
  isAllColumnPinned: boolean,
  resourcesHeaderName: string = "Resources",
): any[] => {
  if (
    !resultsData ||
    !Array.isArray(resultsData) ||
    resultsData.length === 0 ||
    !dashboardData
  ) {
    return [];
  }

  // Get first column keys
  const firstColumnKeys = getFirstColumnKeys(resultsData, recordType);

  // Group fields by prefix
  const groupedFields = groupFieldsByPrefix(
    resultsData,
    dashboardData,
    recordType,
    firstColumnKeys,
  );

  // Separate different types of groups
  const resourceGroup = groupedFields["Resources"];
  const commonColumnsGroup = groupedFields["Common Columns"];

  // Create prefix-specific groups (excluding Resources and Common Columns)
  let movableGroupCounter = 1;
  const prefixGroups = Object.keys(groupedFields)
    .filter((key) => key !== "Resources" && key !== "Common Columns")
    .map((prefix) => {
      const children = groupedFields[prefix].map((field) => ({ field }));
      const hasMoreThanFiveChildren = children.length > 5;

      return {
        groupId: hasMoreThanFiveChildren
          ? `${prefix}|movable-group-${movableGroupCounter++}`
          : prefix,
        headerName: prefix,
        headerAlign: "center" as const,
        children,
        movableClass: hasMoreThanFiveChildren
          ? `movable-group-${movableGroupCounter - 1}`
          : undefined,
      };
    });

  // Build column grouping in the desired order
  const columnGrouping = [
    // 1. Keys section
    {
      groupId: "Keys",
      headerName: "Keys",
      headerAlign: "center",
      children: firstColumnKeys.map((key) => ({ field: key })),
    },
    // 2. Resources section (base resource columns)
    ...(resourceGroup && resourceGroup.length > 0
      ? [
          {
            groupId:
              resourceGroup.length > 5
                ? `Resources|movable-group-${movableGroupCounter++}`
                : "Resources",
            headerName: resourcesHeaderName,
            headerAlign: "center",
            children: resourceGroup.map((field) => ({ field })),
            movableClass:
              resourceGroup.length > 5
                ? `movable-group-${movableGroupCounter - 1}`
                : undefined,
          },
        ]
      : []),
    // 4. Common Columns section
    ...(commonColumnsGroup && commonColumnsGroup.length > 0
      ? [
          {
            groupId: "Common Columns",
            headerName: "Common Columns",
            headerAlign: "center",
            children: commonColumnsGroup.map((field) => ({ field })),
          },
        ]
      : []),
    // 5. Messages section (if applicable)
    {
      groupId: "Messages",
      headerName: "Messages",
      headerAlign: "center",
      children: [{ field: "message" }],
    },
    // 3. Prefix-specific sections

    ...prefixGroups,

    // 6. Actions section
    {
      groupId: "Actions",
      headerName: "Actions",
      headerAlign: "center",
      children: [
        { field: "action" },
        ...(!isAllColumnPinned
          ? [
              { field: "current_status" },
              { field: "username" },
              { field: "comment" },
            ]
          : []),
      ],
    },
  ];

  return columnGrouping;
};

export const groupFieldsByPrefixForSnapshot = (
  resultsData: any[],
  dashboardData: any,
  recordType: RecordType,
  firstColumnKeys: string[],
): GroupedFields => {
  if (!resultsData || !Array.isArray(resultsData) || resultsData.length === 0) {
    return {};
  }

  const firstItem = resultsData[0];

  if (!firstItem) {
    return {};
  }

  const recordData = firstItem?.record_snapshot?.record_data;
  const comparisonKeys = firstItem?.comparison_keys;
  const columnValues = firstItem?.column_values;

  let allFields: string[] = [];

  // Collect all fields from different sources
  const recordDataFields = recordData ? Object.keys(recordData) : [];
  const comparisonKeysFields = comparisonKeys
    ? Object.keys(comparisonKeys)
    : [];
  const columnValuesFields = columnValues ? Object.keys(columnValues) : [];

  // Combine all fields and remove duplicates, excluding first column keys
  const combinedFields = [
    ...recordDataFields,
    ...comparisonKeysFields,
    ...columnValuesFields,
  ];

  allFields = excludeInternalResultFields(
    Array.from(new Set(combinedFields)).filter(
      (key) => !firstColumnKeys.includes(key),
    ),
  );

  const preDefinedPrefixes =
    dashboardData?.additional_properties?.resource_prefixes;

  if (!preDefinedPrefixes || !Array.isArray(preDefinedPrefixes)) {
    return {};
  }

  // Initialize grouped fields structure
  const groupedFields: GroupedFields = {};
  const resourceFields: string[] = [];
  const commonFields: string[] = [];

  allFields.forEach((field) => {
    // Check if field is a base resource column (exact match with prefix)
    if (preDefinedPrefixes.includes(field)) {
      resourceFields.push(field);
      return;
    }

    // Check if field starts with a predefined prefix
    const prefixMatch = preDefinedPrefixes.find((prefix: string) =>
      field.startsWith(`${prefix}_`),
    );

    if (prefixMatch) {
      // Field belongs to a prefix group
      if (!groupedFields[prefixMatch]) {
        groupedFields[prefixMatch] = [];
      }
      groupedFields[prefixMatch].push(field);
      return;
    }

    // Check if field contains a prefix (for Mismatched_ patterns)
    const containsPrefix = preDefinedPrefixes.find(
      (prefix: string) =>
        field.includes(`_${prefix}`) || field.includes(`${prefix}_`),
    );

    if (containsPrefix) {
      // Field belongs to a prefix group
      if (!groupedFields[containsPrefix]) {
        groupedFields[containsPrefix] = [];
      }
      groupedFields[containsPrefix].push(field);
      return;
    }

    // Field doesn't match any prefix pattern, add to common columns
    commonFields.push(field);
  });

  // For missing records, if no resource fields found in data,
  // create them from predefined prefixes (they don't exist in the data structure)
  if (resourceFields.length === 0 && recordType === "missing") {
    resourceFields.push(...preDefinedPrefixes);
  }

  // Add resource fields as a separate group if any exist
  if (resourceFields.length > 0) {
    groupedFields["Resources"] = resourceFields;
  }

  // Add common fields as a separate group if any exist
  if (commonFields.length > 0) {
    groupedFields["Common Columns"] = commonFields;
  }

  return groupedFields;
};

export const getFirstColumnKeysForSnapshot = (
  resultsData: any[],
  recordType: RecordType,
): string[] => {
  if (!resultsData || !Array.isArray(resultsData) || resultsData.length === 0) {
    return ["id"];
  }

  const firstItem = resultsData[0];
  const comparisonKeys = firstItem?.comparison_keys;

  let allKeys = ["id"]; // Start with id

  if (comparisonKeys) {
    allKeys = [...allKeys, ...Object.keys(comparisonKeys)];
  }

  return allKeys;
};

export const createColumnGroupingModelForSnapshot = (
  dashboardData: any,
  resultsData: any[],
  recordType: RecordType,
  isAllColumnPinned: boolean,
  resourcesHeaderName: string = "Resources",
): any[] => {
  if (
    !resultsData ||
    !Array.isArray(resultsData) ||
    resultsData.length === 0 ||
    !dashboardData
  ) {
    return [];
  }

  // Get first column keys
  const firstColumnKeys = getFirstColumnKeysForSnapshot(
    resultsData,
    recordType,
  );

  // Group fields by prefix
  const groupedFields = groupFieldsByPrefixForSnapshot(
    resultsData,
    dashboardData,
    recordType,
    firstColumnKeys,
  );

  // Separate different types of groups
  const resourceGroup = groupedFields["Resources"];
  const commonColumnsGroup = groupedFields["Common Columns"];

  // Create prefix-specific groups (excluding Resources and Common Columns)
  let movableGroupCounter = 1;
  const prefixGroups = Object.keys(groupedFields)
    .filter((key) => key !== "Resources" && key !== "Common Columns")
    .map((prefix) => {
      const children = groupedFields[prefix].map((field) => ({ field }));
      const hasMoreThanFiveChildren = children.length > 5;
      return {
        groupId: hasMoreThanFiveChildren
          ? `${prefix}|movable-group-${movableGroupCounter++}`
          : prefix,
        headerName: prefix,
        headerAlign: "center" as const,
        children,
        movableClass: hasMoreThanFiveChildren
          ? `movable-group-${movableGroupCounter - 1}`
          : undefined,
      };
    });

  // Build column grouping in the desired order
  const columnGrouping = [
    // 1. Keys section
    {
      groupId: "Keys",
      headerName: "Keys",
      headerAlign: "center",
      children: firstColumnKeys.map((key) => ({ field: key })),
    },
    // 2. Resources section (base resource columns)
    ...(resourceGroup && resourceGroup.length > 0
      ? [
          {
            groupId:
              resourceGroup.length > 5
                ? `Resources|movable-group-${movableGroupCounter++}`
                : "Resources",
            headerName: resourcesHeaderName,
            headerAlign: "center",
            children: resourceGroup.map((field) => ({ field })),
            movableClass:
              resourceGroup.length > 5
                ? `movable-group-${movableGroupCounter - 1}`
                : undefined,
          },
        ]
      : []),
    // 4. Common Columns section
    ...(commonColumnsGroup && commonColumnsGroup.length > 0
      ? [
          {
            groupId: "Common Columns",
            headerName: "Common Columns",
            headerAlign: "center",
            children: commonColumnsGroup.map((field) => ({ field })),
          },
        ]
      : []),
    // 5. Messages section (if applicable)
    {
      groupId: "Messages",
      headerName: "Messages",
      headerAlign: "center",
      children: [{ field: "message" }],
    },
    // 3. Prefix-specific sections

    ...prefixGroups,

    // 6. Actions section
    {
      groupId: "Actions",
      headerName: "Actions",
      headerAlign: "center",
      children: [
        { field: "action" },
        ...(!isAllColumnPinned
          ? [
              { field: "current_status" },
              { field: "username" },
              { field: "comment" },
            ]
          : []),
      ],
    },
  ];

  return columnGrouping;
};

// Helper function to normalize job_status to lowercase
export const normalizeJobStatus = (item: any) => {
  if (item && item.job_status && typeof item.job_status === "string") {
    return {
      ...item,
      job_status: item.job_status.toLowerCase(),
    };
  }
  return item;
};
